import { Component } from '@angular/core';

@Component({
  selector: 'itl-desktop-list-item-icon',
  template: '<ng-content></ng-content>',
  standalone: false,
})
export class DesktopListItemIconComponent {}
